module.exports = __webpack_public_path__ + "static/img/1_25_1.4cb9c713.png";